import { useEffect, useRef, useState } from "react";
import { ReactComponent as Upload } from "../../../../icons/upload-icon.svg";
import UpdateDemandDataModal from "../Resource/Popup/uploadDemand";
import loader from "../../../../components/recharts/loader.gif";
import {
  ChartDataParams,
  FormatChartData,
} from "../../../../components/recharts/functions";
import { BrushStart, ChartType } from "../../../../models/chart_model";
import { ReMixChart } from "../../../../components/recharts/ReMixCharts";
import { renderHourTick } from "../../../../components/recharts/components";
import { useSelector } from "react-redux";
import { ReactComponent as Undo } from "../../../../icons/undo.svg";
import {
  fetchModDemandDefault,
  // ModDemandData,
} from "../../../../Rest_api/RestApi";
import { ModLoadDataUpdate } from "../../../../store/state/ModLoadState";
import { useDispatch } from "react-redux";
import { normalizeDisplayLabelWithoutUndefined } from "../../../../utility/displayText";
const chartSuffixes = [
  {
    suffix: "target_day",
    displayName: "Target Day Demand",
    stackSuffix: "target_day",
    stroke: "rgba(150, 114, 22, 1)",
    unit: "MW",
    yAxisId: "left",
  },
  {
    suffix: "previous_target_day",
    displayName: "Previous Day Demand",
    stackSuffix: "previous_target_day",
    stroke: "rgba(251, 191, 36, 1)",
    unit: "MW",
    yAxisId: "left",
  },
];

const DemandPriceAnalysis = ({
  selectedBlock,
  loading,
  setData,
  data,
}: {
  selectedBlock: any[];
  loading: boolean;
  setData: React.Dispatch<React.SetStateAction<any[]>>;
  data: any[];
}) => {
  const [chartData, setChartData] = useState<any[]>([]);
  const [chartKeys, setChartKeys] = useState<any[]>([]);
  const preSelectedDate = useSelector(
    (state: any) => state.modGridcoDate.selectedDate
  );
  const modSelectedSession = useSelector(
    (state: any) => state.modGridcoSession.modSession
  );
  const dispatch = useDispatch();

  // Reset button
  const handleReset = async () => {
    try {
      const res = await fetchModDemandDefault(
        preSelectedDate,
        modSelectedSession
      );

      if (!res) return;

      const demandDate = res.date;

      // Build payload for saving
      // const jsonUploadData = {
      //   date: preSelectedDate,
      //   session: modSelectedSession,
      //   data: res.data,
      // };

      // Transform for table/UI
      const transformedData = res.data.map((item: any) => ({
        time_slot: item.time_slot,
        date: demandDate,
        target_day: item.demand_mw,
        previous_target_day: item.previous_demand_mw,
      }));

      // Transform for redux state
      const dispatchData = res.data.map((item: any) => ({
        Date: demandDate,
        Demand: item.demand_mw,
      }));

      // Update redux
      dispatch(ModLoadDataUpdate({ type: "demand", data: dispatchData }));

      // Update local state
      setData(transformedData);

      // Save modified demand data
      // await ModDemandData(jsonUploadData);
    } catch (err) {
      console.error("Reset failed:", err);
    }
  };

  useEffect(() => {
    let filteredData = data;
    if (selectedBlock.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedBlock
          .map((item) => Number(item.value))
          .includes(Number(item.time_slot))
      );
    }

    const par: ChartDataParams = {
      keys: ["time_slot", "date", "month"],
      tableKeys: ["date", "time_slot", "month"],
      groupBy: [],
      volumeKey: ``,
      aggregationKeys: ["target_day", "previous_target_day"],
      priceKey: "",
      data: filteredData,
    };

    const cData = FormatChartData(par);
    setChartData(cData.data);
    setChartKeys(cData.keys);
  }, [data, selectedBlock]);

  const createChartObject = (
    key: string,
    index: number,
    suffix: string,
    displayName: string,
    stackSuffix: string,
    stroke: string,
    unit: string,
    yAxisId: string
  ) => {
    return {
      dataKey: `${key}_${suffix}`,
      name: `${normalizeDisplayLabelWithoutUndefined(key)} ${displayName}`,
      legendColor: undefined,
      type: ChartType.Line,
      stroke: stroke,
      unit: unit,
      yAxisId: yAxisId,
      stackId: stackSuffix !== undefined ? stackSuffix : undefined,
    };
  };

  function getLegends() {
    return chartSuffixes.flatMap(
      ({ suffix, displayName, stackSuffix, stroke, unit, yAxisId }) =>
        chartKeys.map(
          (key, index) =>
            createChartObject(
              key,
              index,
              suffix,
              displayName,
              stackSuffix,
              stroke,
              unit,
              yAxisId
            ) as any
        )
    );
  }

  return (
    <>
      {/* {loading && <Loading />} */}
      <div className="dash-card col-span-1 md:col-span-6 border border-[#718EBF1C] !bg-[#fff] !shadow-[rgba(149,157,165,0.2)_0px_8px_24px] !min-h-full w-full">
        <div className="flex justify-between items-center mb-4">
          <button
            onClick={handleReset}
            className="flex items-center gap-1 text-sm  text-[#6F6D7C] font-medium"
          >
            <Undo className="w-4 h-4" />
            Reset
          </button>
          <div className="">
            <h2 className="chartHeading !text-[#34656D] !font-medium">
              Anticipated Load
            </h2>
          </div>

          <UploadBtn
            data={data}
            setData={setData}
            modalTitle="Upload Demand Data"
            preSelectedDate={preSelectedDate}
          />
        </div>

        {loading ? (
          <div className="h-full w-full bg-white relative">
            <img
              src={loader}
              width={200}
              alt="loader"
              className="absolute inset-0 m-auto"
            />
          </div>
        ) : (
          <>
            {" "}
            {data.length === 0 ? (
              <>
                <div className="flex justify-center items-center h-full">
                  <p className="text-gray-500 text-[14px]">
                    Kindly click the Upload button to upload data.
                  </p>
                </div>
              </>
            ) : (
              <ReMixChart
                tooltipBoundary="viewport"
                chartHeight="calc(100% - 50px)"
                data={chartData}
                showBrush={chartData.length > 96 ? true : undefined}
                brushStart={BrushStart.End}
                isTimeSlot={true}
                onlyTitle={true}
                legends={getLegends()}
                yAxisLabel="MW"
                nameGap={40}
                top={10} // Top margin for grid
                bottom={30} // Bottom margin for grid
                xDataKey={"time_slot"}
                xTick={(value: any, index: any) => {
                  return renderHourTick(value, 10);
                }}
                secondXDataKey={"date"}
                showToolbox={false}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default DemandPriceAnalysis;

function UploadBtn({
  data,
  setData,
  modalTitle,
  preSelectedDate,
}: {
  data: any[];
  setData: React.Dispatch<React.SetStateAction<any[]>>;
  modalTitle?: string;
  preSelectedDate?: string;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <div className="upload_btn">
      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        className="flex items-center gap-2 text-sm  text-[#6F6D7C] font-medium"
      >
        Upload
        <Upload className="w-5 h-5" />
      </button>

      <UpdateDemandDataModal
        data={data}
        setData={setData}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        modalTitle={modalTitle || "Upload template"}
        preSelectedDate={preSelectedDate}
      />
    </div>
  );
}
